import {
  Button,
  createTableColumn,
  Link,
  TableColumnDefinition,
} from "@fluentui/react-components";
import i18n from "i18next";
import { ITeamRequest } from "../../../Models/ITeamRequest";
import {
  CheckmarkFilled,
  CheckmarkRegular,
  DismissRegular,
} from "@fluentui/react-icons";

interface IMyInvitesColumns {
  onDecline(item: ITeamRequest): void;
  onAccept(item: ITeamRequest): void;
}

export function MyInvitesColumns(props: IMyInvitesColumns) {
  const columns: TableColumnDefinition<ITeamRequest>[] = [
    createTableColumn<ITeamRequest>({
      columnId: "teamname",
      compare: (a, b) => {
        if (a.team.teamname && b.team.teamname) {
          return a.team.teamname.localeCompare(b.team.teamname);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Teamname";
      },
      renderCell: (item: ITeamRequest) => {
        return <div>{item.team.teamname}</div>;
      },
    }),
    createTableColumn<ITeamRequest>({
      columnId: "inviter",
      compare: (a, b) => {
        if (a.createdBy.fullName && b.createdBy.fullName) {
          return a.createdBy.fullName.localeCompare(b.createdBy.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("inviter");
      },
      renderCell: (item: ITeamRequest) => {
        return <div>{item.createdBy.fullName}</div>;
      },
    }),
    createTableColumn<ITeamRequest>({
      columnId: "actions",
      compare: (a, b) => {
        if (a.createdBy.fullName && b.createdBy.fullName) {
          return a.createdBy.fullName.localeCompare(b.createdBy.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "";
      },
      renderCell: (item: ITeamRequest) => {
        return (
          <div style={{ display: "flex", width: "100%" }}>
            <Button
              style={{ marginRight: "5px" }}
              icon={<CheckmarkFilled />}
              appearance="primary"
              className="lueb-marginRight10"
              onClick={() => {
                props.onAccept(item);
                /* setErrorMessageLine(index); */
              }}
            >
              {i18n.t<string>("accept")}
            </Button>
            <Button
              icon={<DismissRegular />}
              onClick={() => {
                props.onDecline(item);
                /* setErrorMessageLine(index); */
              }}
            >
              {i18n.t<string>("decline")}
            </Button>
          </div>
        );
      },
    }),
  ];
  return columns;
}
